import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-wizard-tabs',
  templateUrl: './wizard-tabs.component.html',
  styleUrls: ['./wizard-tabs.component.scss']
})
export class WizardTabsComponent implements OnInit {
  @Input() steps = [] as any;

  @Input() theme : {color:'default'| 'light' | 'dark', appearance: 'stacked' | 'default'} = {color:'light',appearance:'default'}
  @Output() onStepChanged = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  switchStep(selectedStep) {
    this.steps.forEach(step => {
      step.isActive = false;
    });
    selectedStep.isActive = true;
    this.onStepChanged.emit(selectedStep);
  }

}
